import { ConfirmRestore } from '@organization/models'

import { ssoAxios } from './axios'
import { ChangePasswordResponse } from '@organization/types'

const _getAccountHeaders = (token: string) => ({ Authorization: `Token ${token}` })

const _getAccountConfig = (token: string) => ({
  headers: _getAccountHeaders(token),
  skipAuthHeader: true  
})

export const account = {
  confirmRestore: async (body: ConfirmRestore) => {
    const { data } = await ssoAxios.post<ConfirmRestore>(
      '/account/confirm-restore/',
      body
    )

    return data
  },  

  changePasswordRequest: async () => {
    const { data } = await ssoAxios.post<ChangePasswordResponse>('/account/change-password-request/')

    return data
  },


  
  changePasswordConfirm: async (body: {password: string, confirm_password: string,token : string}, ) => {
    const { token ,...values} = body

    const { data } = await ssoAxios.post<void>('/account/change-password-confirm/', values, 
     
      _getAccountConfig(token)
    )

    return data
  }
}
